import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import ProductCard from './ProductCard';

const ProductList = ({ products, activeProduct, onProductChange }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => onProductChange(products[current].title),
    adaptiveHeight: true,
  };

  return (
    <div className="mb-6">
      {isMobile ? (
        <div className="mx-auto">
          <Slider {...settings}>
            {products.map((product, index) => (
              <div key={index} className="px-1">
                <ProductCard
                  {...product}
                  isActive={activeProduct === product.title}
                  onClick={() => onProductChange(product.title)}
                />
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {products.map((product, index) => (
            <ProductCard
              key={index}
              {...product}
              isActive={activeProduct === product.title}
              onClick={() => onProductChange(product.title)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductList; 